import React from "react";

const OrderCongratulationsPage: React.FC = () => {
  return <div>OrderCongratulationsPage</div>;
};

export default OrderCongratulationsPage;
